<template>
  <resource-edit-wrapper
    :title="$t('resources.calendars.edit_calendar')"
    :need-modal="showModal"
    :show-bottom-actions="true"
    @saveAction="$refs['calendarForm'].submit()"
    ref="resourceCreateWrapper">
    <CalendarForm
      is-edit
      :calendar="item"
      @isDirtyForm="isDirtyForm"
      ref="calendarForm"
      @finishedSaving="finishedSaving"></CalendarForm>
    <template #actions>
      <v-btn @click="cancel" outlined color="primary" class="spacing-right--16">
        {{ $t("generic.buttons.cancel") }}
      </v-btn>
      <v-btn @click="save" color="primary" :loading="saveLoading">
        {{ $t("generic.buttons.save") }}
      </v-btn>
    </template>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";
  import CalendarForm from "@/components/forms/CalendarForm";

  export default {
    components: {
      ResourceEditWrapper,
      CalendarForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        saveLoading: false,
      };
    },
    created() {
      this.$admin.toast.info(this.$t("generic.edit_warning.warning") + this.$t("generic.edit_warning.calendar"));
    },
    methods: {
      save() {
        this.showModal = false;
        this.saveLoading = true;
        this.$refs["calendarForm"].submit(this.$t("resources.calendars.calendar_updated"));
      },
      cancel() {
        this.$refs.resourceCreateWrapper.cancelButtonHandler();
      },
      finishedSaving() {
        this.saveLoading = false;
      },
    },
  };
</script>
